import React from 'react';
import css from './text-button.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export default function TextButton({
  name,
  onClick,
  icon = faPlus,
  className = '',
}: {
  name: string;
  onClick: (event) => void;
  icon?: IconProp;
  className?: string;
}) {
  return (
    <button
      className={`${css['text-button']} ${css[className]}`}
      type="button"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={icon} /> {name}
    </button>
  );
}
